(function () {
  'use strict';

  var ALLOWED_EXTS  = ['.pdf', '.jpg', '.jpeg', '.png'];
  var ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
  var submitting    = false;

  // Hard-coded ceilings matching the certified backend contract.
  // These cannot be overridden by the Theme Editor — they reflect actual
  // Vercel platform limits, not aspirational figures.
  var HARD_PER_FILE_BYTES  = 3 * 1024 * 1024;               // 3 MiB per file
  var HARD_AGGREGATE_BYTES = 3 * 1024 * 1024 + 512 * 1024;  // 3.5 MiB total attachments

  function init() {
    var root      = document.getElementById('gsr-root');
    if (!root) return;
    var form      = document.getElementById('gsr-form');
    var submitBtn = document.getElementById('gsr-submit-btn');
    if (!form || !submitBtn) return;

    var maxBytes = Math.min(
      parseInt(root.dataset.maxMb || '3', 10) * 1024 * 1024,
      HARD_PER_FILE_BYTES
    );

    // Phone auto-format
    var phoneInput = form.querySelector('input[name="phone"]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var fmt = formatPhone(phoneInput.value);
        if (fmt !== phoneInput.value) phoneInput.value = fmt;
      });
    }

    // Equipment "Other" reveal
    setupSelectReveal(
      form.querySelector('select[name="equipment_type"]'),
      document.getElementById('gsr-equipment-other-wrap'),
      'Other'
    );

    // "Purchased from Gilgal" → order number reveal
    form.querySelectorAll('input[name="purchased_from_gilgal"]').forEach(function (r) {
      r.addEventListener('change', function () { updateOrderReveal(form); });
    });
    updateOrderReveal(form);

    // File inputs — per-file validation on change
    root.querySelectorAll('.gii-upload-box').forEach(function (box) {
      var input      = box.querySelector('input[type="file"]');
      var primaryTxt = box.querySelector('.gii-upload-text__primary');
      var defaultTxt = primaryTxt ? primaryTxt.textContent : '';
      var item       = box.closest('.gii-upload-item');
      var uploadErr  = item ? item.querySelector('.gii-upload__error') : null;
      if (!input) return;
      input.addEventListener('change', function () {
        var file = input.files[0];
        clearUploadError(box, uploadErr);
        if (!file) {
          box.classList.remove('gii-upload-box--has-file', 'gii-upload-box--error');
          if (primaryTxt) primaryTxt.textContent = defaultTxt;
          return;
        }
        var err = fileError(file, maxBytes);
        if (err) {
          box.classList.add('gii-upload-box--error');
          box.classList.remove('gii-upload-box--has-file');
          showErr(uploadErr, err);
          input.value = '';
          if (primaryTxt) primaryTxt.textContent = defaultTxt;
        } else {
          box.classList.add('gii-upload-box--has-file');
          if (primaryTxt) primaryTxt.textContent = file.name;
        }
      });
    });

    // Submit
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;
      if (validate(root, maxBytes) > 0) return;

      var endpoint = root.dataset.endpoint;

      if (!endpoint) {
        var notice = document.getElementById('gsr-staging-notice');
        if (notice) {
          notice.style.display = 'block';
          notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      submitting = true;
      setLoading(submitBtn, true);
      clearFormError(root);

      var formData = new FormData(form);
      resolveOther(form, formData, 'equipment_type', 'equipment_type_other');

      // No x-api-key header — authentication handled server-side by the Worker
      fetch(endpoint, { method: 'POST', body: formData })
        .then(function (res) {
          return res.json().then(function (data) { return { status: res.status, data: data }; });
        })
        .then(function (result) {
          setLoading(submitBtn, false);
          submitting = false;
          if (result.status === 200 && result.data.ok) {
            form.style.display = 'none';
            var successEl = document.getElementById('gsr-success');
            if (successEl) {
              if (result.data.request_number) {
                var bodyEl = successEl.querySelector('.gii-message__body');
                if (bodyEl) {
                  bodyEl.insertAdjacentHTML(
                    'beforeend',
                    '<br><strong>Reference ' + result.data.request_number + '</strong>'
                  );
                }
              }
              successEl.style.display = 'block';
              successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
          }
          var msg;
          if (result.status === 401 || result.status === 403) {
            msg = 'We could not verify your request. Please try again or call us at (855) 228-3625.';
          } else if (result.status === 413) {
            msg = 'Your attachments are too large. Please reduce file sizes and try again.';
          } else if (result.status === 422) {
            msg = result.data.error || 'Some required fields are missing. Please review your entries.';
          } else {
            msg = 'We could not submit your request. Please try again or call us at (855) 228-3625.';
          }
          showFormError(root, msg);
        })
        .catch(function () {
          setLoading(submitBtn, false);
          submitting = false;
          showFormError(root, 'A network error occurred. Please check your connection and try again.');
        });
    });
  }

  // ── Phone formatting ─────────────────────────────────────────────────────

  function formatPhone(raw) {
    var digits = raw.replace(/\D/g, '').slice(0, 10);
    if (digits.length < 4)  return digits;
    if (digits.length < 7)  return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  // ── Conditional reveal helpers ───────────────────────────────────────────

  function setupSelectReveal(selectEl, wrapEl, triggerValue) {
    if (!selectEl || !wrapEl) return;
    function update() {
      var show = selectEl.value === triggerValue;
      wrapEl.style.display = show ? 'block' : 'none';
      wrapEl.setAttribute('aria-hidden', show ? 'false' : 'true');
      var input = wrapEl.querySelector('input, textarea');
      if (input) {
        if (show) {
          input.setAttribute('data-required', '');
          input.setAttribute('aria-required', 'true');
        } else {
          input.removeAttribute('data-required');
          input.removeAttribute('aria-required');
          input.value = '';
          clearFieldError(input, wrapEl.querySelector('.gii-field__error'));
        }
      }
    }
    selectEl.addEventListener('change', update);
    update();
  }

  function updateOrderReveal(form) {
    var wrapEl  = document.getElementById('gsr-order-number-wrap');
    if (!wrapEl) return;
    var checked = form.querySelector('input[name="purchased_from_gilgal"]:checked');
    var show    = checked && checked.value === 'yes';
    wrapEl.style.display = show ? 'block' : 'none';
    wrapEl.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (!show) {
      var input = wrapEl.querySelector('input');
      if (input) { input.value = ''; clearFieldError(input, wrapEl.querySelector('.gii-field__error')); }
    }
  }

  function resolveOther(form, formData, selectName, otherName) {
    var select = form.querySelector('select[name="' + selectName + '"]');
    if (!select || select.value !== 'Other') { formData.delete(otherName); return; }
    var otherInput = form.querySelector('[name="' + otherName + '"]');
    formData.set(selectName, (otherInput ? otherInput.value.trim() : '') || 'Other');
    formData.delete(otherName);
  }

  // ── Validation ───────────────────────────────────────────────────────────

  function validate(root, maxBytes) {
    var errors    = 0;
    var errorList = [];

    var summary = document.getElementById('gsr-error-summary');
    if (summary) { summary.innerHTML = ''; summary.style.display = 'none'; }

    // Required text / select / textarea — skip hidden conditional fields
    root.querySelectorAll('input[data-required], select[data-required], textarea[data-required]').forEach(function (el) {
      if (isHidden(el)) return;
      var wrap  = el.closest('.gii-field');
      var errEl = wrap ? wrap.querySelector('.gii-field__error') : null;
      clearFieldError(el, errEl);
      if (!(el.value || '').trim()) {
        var label = wrap ? (wrap.querySelector('label') || wrap.querySelector('legend')) : null;
        var name  = label ? label.textContent.trim().replace(/\s*\*$/, '') : (el.getAttribute('aria-label') || 'Field');
        setFieldError(el, errEl, el.dataset.errorMsg || 'This field is required.');
        errorList.push(name + ' is required.');
        errors++;
      }
    });

    // Required radio groups (fieldset[data-required])
    root.querySelectorAll('fieldset[data-required]').forEach(function (fs) {
      if (isHidden(fs)) return;
      var errEl = fs.querySelector('.gii-field__error');
      if (errEl) clearErr(errEl);
      if (!fs.querySelector('input[type="radio"]:checked')) {
        var legend = fs.querySelector('legend');
        var name   = legend ? legend.textContent.trim() : 'Selection';
        if (errEl) showErr(errEl, 'Please make a selection.');
        errorList.push(name + ': please make a selection.');
        errors++;
      }
    });

    // Required checkboxes
    root.querySelectorAll('input[type="checkbox"][data-required]').forEach(function (cb) {
      if (isHidden(cb)) return;
      var wrap  = cb.closest('.gii-field');
      var errEl = wrap ? wrap.querySelector('.gii-field__error') : null;
      if (errEl) clearErr(errEl);
      if (!cb.checked) {
        if (errEl) showErr(errEl, 'This acknowledgement is required.');
        errorList.push('Required consent not checked.');
        errors++;
      }
    });

    // Format checks
    errors += runFormatCheck(root, 'phone', validatePhone, errorList);
    errors += runFormatCheck(root, 'email', validateEmail, errorList);
    errors += runFormatCheck(root, 'zip',   validateZip,   errorList);

    // File uploads — per-file, then aggregate
    var totalBytes = 0;
    root.querySelectorAll('.gii-upload-box').forEach(function (box) {
      var input = box.querySelector('input[type="file"]');
      if (!input || !input.files || !input.files[0]) return;
      var item  = box.closest('.gii-upload-item');
      var errEl = item ? item.querySelector('.gii-upload__error') : null;
      var err   = fileError(input.files[0], maxBytes);
      if (err) {
        box.classList.add('gii-upload-box--error');
        showErr(errEl, err);
        errorList.push(err);
        errors++;
      } else {
        totalBytes += input.files[0].size;
      }
    });
    if (errors === 0 && totalBytes > HARD_AGGREGATE_BYTES) {
      showFormError(root, 'Combined attachments exceed the 3.5 MB total limit. Please use smaller or fewer files.');
      errorList.push('Combined attachments exceed the 3.5 MB limit.');
      errors++;
    }

    // Error summary
    if (errorList.length && summary) {
      var html = '<p class="gsr-error-summary__title">Please correct the following:</p><ul>';
      errorList.forEach(function (item) { html += '<li>' + item + '</li>'; });
      html += '</ul>';
      summary.innerHTML = html;
      summary.style.display = 'block';
      summary.focus();
    } else if (!errorList.length && errors === 0) {
      // pass
    } else if (errors > 0 && !summary) {
      var first = root.querySelector('[aria-invalid="true"]');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return errors;
  }

  function isHidden(el) {
    var p = el;
    while (p) {
      if (p.getAttribute && p.getAttribute('aria-hidden') === 'true') return true;
      if (p.style && p.style.display === 'none') return true;
      p = p.parentElement;
    }
    return false;
  }

  function runFormatCheck(root, name, fn, errorList) {
    var el = root.querySelector('[name="' + name + '"]');
    if (!el || isHidden(el)) return 0;
    var val = (el.value || '').trim();
    if (!val || el.getAttribute('aria-invalid') === 'true') return 0;
    var wrap  = el.closest('.gii-field');
    var errEl = wrap ? wrap.querySelector('.gii-field__error') : null;
    var err   = fn(val);
    if (err) { setFieldError(el, errEl, err); errorList.push(err); return 1; }
    return 0;
  }

  function validatePhone(val) {
    return val.replace(/\D/g, '').length !== 10 ? 'Please enter a valid 10-digit phone number.' : null;
  }
  function validateEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) ? null : 'Please enter a valid email address.';
  }
  function validateZip(val) {
    return /^\d{5}(-\d{4})?$/.test(val) ? null : 'Please enter a valid ZIP code (e.g. 33101).';
  }
  function fileError(file, maxBytes) {
    var ext    = (file.name.match(/\.[^.]+$/) || [''])[0].toLowerCase();
    var okExt  = ALLOWED_EXTS.indexOf(ext) > -1;
    var okMime = ALLOWED_TYPES.indexOf(file.type) > -1;
    if (!okExt && !okMime) return 'Only JPG, PNG, and PDF files are accepted.';
    if (file.size > maxBytes) return 'File exceeds ' + Math.round(maxBytes / 1048576) + ' MB limit.';
    return null;
  }

  // ── DOM helpers ──────────────────────────────────────────────────────────

  function setFieldError(el, errEl, msg) {
    el.setAttribute('aria-invalid', 'true');
    if (errEl) el.setAttribute('aria-describedby', errEl.id || '');
    showErr(errEl, msg);
  }
  function clearFieldError(el, errEl) {
    el.removeAttribute('aria-invalid');
    el.removeAttribute('aria-describedby');
    clearErr(errEl);
  }
  function clearUploadError(box, errEl) {
    box.classList.remove('gii-upload-box--error');
    clearErr(errEl);
  }
  function showErr(el, msg)  { if (el) { el.textContent = msg; el.classList.add('gii-visible'); } }
  function clearErr(el)      { if (el) { el.textContent = '';  el.classList.remove('gii-visible'); } }

  function setLoading(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('gii-submit-btn--loading', on);
    var txt = btn.querySelector('.gii-submit-btn__text');
    if (txt) txt.textContent = on ? 'Sending Request…' : 'Submit Service Request';
  }

  function showFormError(root, msg) {
    var el = document.getElementById('gsr-form-error');
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function clearFormError(root) {
    var el = document.getElementById('gsr-form-error');
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }

  // ── Boot ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
